import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const CourseDebugPage = () => {
  const { courseId } = useParams();
  const [debugInfo, setDebugInfo] = useState('Loading...');

  useEffect(() => {
    fetchDebugInfo();
  }, [courseId]);

  const fetchDebugInfo = async () => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${backendUrl}/api/video-lessons/course/${courseId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      const data = await response.json();
      
      setDebugInfo(JSON.stringify({
        status: response.status,
        dataType: typeof data,
        isArray: Array.isArray(data),
        hasLessonsKey: data?.lessons !== undefined,
        lessonsType: typeof data?.lessons,
        lessonsIsArray: Array.isArray(data?.lessons),
        data: data
      }, null, 2));
    } catch (error) {
      setDebugInfo(`Error: ${error.message}\n${error.stack}`);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-green-400 p-8 font-mono">
      <h1 className="text-2xl mb-4">Course API Debug</h1>
      <p className="mb-2">Course ID: {courseId}</p>
      <pre className="bg-black p-4 rounded overflow-auto">
        {debugInfo}
      </pre>
      <button
        onClick={fetchDebugInfo}
        className="mt-4 bg-green-600 text-white px-4 py-2 rounded"
      >
        Refresh
      </button>
    </div>
  );
};

export default CourseDebugPage;
